var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0563965 16C0.0563965 7.16344 7.21984 0 16.0564 0C24.893 0 32.0564 7.16344 32.0564 16C32.0564 24.8366 24.893 32 16.0564 32C7.21984 32 0.0563965 24.8366 0.0563965 16ZM22.1564 11.5C22.8564 11.4 23.4564 11.3 24.0564 11C23.6564 11.7 23.0564 12.3 22.3564 12.7C22.5564 17.4 19.1564 22.5 13.0564 22.5C11.2564 22.5 9.5564 21.9 8.0564 21C9.7564 21.2 11.5564 20.7 12.7564 19.8C11.2564 19.8 10.0564 18.8 9.6564 17.5C10.1564 17.6 10.6564 17.5 11.1564 17.4C9.6564 17 8.5564 15.6 8.5564 14.1C9.0564 14.3 9.5564 14.5 10.0564 14.5C8.6564 13.5 8.1564 11.6 9.0564 10.1C10.7564 12.1 13.1564 13.4 15.8564 13.5C15.3564 11.5 16.9564 9.5 19.0564 9.5C19.9564 9.5 20.8564 9.9 21.4564 10.5C22.2564 10.3 22.9564 10.1 23.5564 9.7C23.3564 10.5 22.8564 11.1 22.1564 11.5Z",
    fill: "#F0EFEF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.543c62ab1b54a8c8f51bc523a831e26f.svg";
export { ForwardRef as ReactComponent };